import { render, staticRenderFns } from "./ContactPerson.vue?vue&type=template&id=f1333b76&scoped=true&"
import script from "./ContactPerson.vue?vue&type=script&lang=js&"
export * from "./ContactPerson.vue?vue&type=script&lang=js&"
import style0 from "./ContactPerson.vue?vue&type=style&index=0&id=f1333b76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1333b76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VTab,VTabItem,VTabs,VTabsItems,VTabsSlider})
